import { cookieAction } from './cookiesAction';
import { dialogAction } from './dialogAction';
export const useActions = (state, dispatch) => {
    return {
        cookieAction: cookieAction({ state, dispatch }),
        dialogAction: dialogAction({ state, dispatch }),
    };
};
